import { useContext } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { globalStore } from '../state/store';

export default function SelectAdvanced(props) {

  const [state, dispatch] = useContext(globalStore);
  const isCPAnswerSheet = Boolean(state.user) && state.user.uid === 'hyPRV6TXakMbalAtyb33uDFsOJb2';

  return (
    <Autocomplete
      sx={{ width: '100%' }}
      options={state.teams}
      autoHighlight
      multiple={isCPAnswerSheet}
      disabled={state.closedForEditing}
      value={
        isCPAnswerSheet ? 
          (props.value ? state.teams.filter((t) => props.value.includes(t._id)) : []) :
        (!isCPAnswerSheet && props.value && state.teams.filter((t) => t._id === props.value)[0]) ? 
          state.teams.filter((t) => t._id === props.value)[0] : 
          null
      }
      onChange={(event, newValue) => {
        if (isCPAnswerSheet) {
          props.handleChangeValue(newValue ? newValue.map(v => v._id) : []);
        } else {
          props.handleChangeValue(newValue ? newValue._id : null);
        }
      }}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, py:1, flexShrink: 0 } }} {...props}>
          <img width="25" src={option.flag} alt={option.name} />
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Select team" + (isCPAnswerSheet ? "(s)" : "")}
          placeholder={"Select " + (isCPAnswerSheet ? "teams..." : "a team...")}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}